import { render } from "./SelectDateV2.vue?vue&type=template&id=1b3732ec&ts=true"
import script from "./SelectDateV2.vue?vue&type=script&lang=ts"
export * from "./SelectDateV2.vue?vue&type=script&lang=ts"

import "./SelectDateV2.vue?vue&type=style&index=0&id=1b3732ec&lang=css"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__